import DraftJS from 'draft-js';
import {filterAllowedUnicodeCharsRegex} from 'utils/types/regex';
import getFullTextFromEditorState from './get-full-text-from-editor-state';

const {
  ContentState: {createFromText},
  EditorState: {createWithContent},
} = DraftJS;
//  TO-DO: Move to new utils structure.

export function filterAllowedUnicodeCharsFromText(text: string): string {
  return text?.replace(filterAllowedUnicodeCharsRegex, '');
}

export function getCompositionRaw(
  editorState?: any,
  compositionRawText?: string,
  isMobile?: boolean,
): string {
  if (isMobile || compositionRawText) {
    return filterAllowedUnicodeCharsFromText(compositionRawText ?? '');
  }
  if (editorState) {
    const editorText = getFullTextFromEditorState(editorState).join('\n\n');
    const cleanedEditorText = filterAllowedUnicodeCharsFromText(editorText);
    return cleanedEditorText;
  }
  return '';
}
export function getSanitizedEditorState(
  editorText: string,
  editorState: any,
): any {
  if (!editorText.match(filterAllowedUnicodeCharsRegex)) {
    return editorState;
  }
  const cleanedText = filterAllowedUnicodeCharsFromText(editorText).replace(
    /\n+/g,
    `\n`,
  );

  const textContentState = createFromText(cleanedText);
  const newEditorState = createWithContent(textContentState);

  const oldEditorText = getFullTextFromEditorState(editorState).join('\n\n');
  const newEditorText = getFullTextFromEditorState(newEditorState).join('\n\n');

  if (oldEditorText !== newEditorText) {
    return newEditorState;
  }
  return editorState;
}
